import React from "react";
import { Line } from "react-chartjs-2";
import type { ChartData, Plugin } from "chart.js";

import RebetLoaderJs from "../RebetLoader/RebetLoader";

import "./chartSetup";
import { buildChartOptions } from "./chartTheme";

const RebetLoader = RebetLoaderJs as React.ComponentType<{
  width: number;
  height: number;
}>;

export interface LineChartProps {
  data: ChartData<"line">;
  // chart-specific options, deep-merged onto the shared theme
  optionsOverride?: Record<string, unknown>;
  // per-instance plugins, e.g. [ChartDataLabels]
  plugins?: Plugin<"line">[];
  isLoading?: boolean;
  loaderSize?: number;
}

const loaderWrapperStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
};

const LineChart: React.FC<LineChartProps> = ({
  data,
  optionsOverride,
  plugins,
  isLoading = false,
  loaderSize = 100,
}) => {
  if (isLoading) {
    return (
      <div style={loaderWrapperStyle}>
        <RebetLoader width={loaderSize} height={loaderSize} />
      </div>
    );
  }

  const options = buildChartOptions(optionsOverride);

  return <Line data={data} options={options as never} plugins={plugins} />;
};

export default LineChart;
